import { render } from "./TvmSignInNavigation.vue?vue&type=template&id=4b1b11e0"
import script from "./TvmSignInNavigation.js?vue&type=script&lang=js&external"
export * from "./TvmSignInNavigation.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/TvmSignInNavigation/TvmSignInNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b1b11e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b1b11e0', __exports__)) {
    api.reload('4b1b11e0', __exports__)
  }
  
  module.hot.accept("./TvmSignInNavigation.vue?vue&type=template&id=4b1b11e0", () => {
    api.rerender('4b1b11e0', render)
  })

}


export default __exports__